import React, { Component, PropTypes } from 'react';
import { Col, ControlLabel, FormGroup } from 'react-bootstrap';

class YearOfManufacture extends Component {

  constructor(props) {
    super(props);
    const nextYear = (new Date()).getFullYear()
    const option = [];
    for (let i = 0; i < 16; i++) {
      const tempYear = nextYear - i
      option.push(tempYear)
    }

    this.state = {
      errorLevel: 'normal',
      option
    }
  }

  render() {
    return (
      <FormGroup controlId="yearOfManufacture">
        <Col componentClass={ControlLabel} sm={5}>
          Year Of Manufacture *
        </Col>
        <Col sm={7}>
            <select
              className="custom-select"
              name="yearOfManufacture"
              onChange={this.props.handleChangeYearOfManufacture}
              value={this.props.yearOfManufacture}
              required
            >
            <option value="">Please select</option>
            {this.state.option.map((obj, index) => {
              const counter = index
              return (
                <option
                  value={obj}
                  key={counter}
                >{obj}</option>
              );
            })}
          </select>
        </Col>

      </FormGroup>
    )
  }
}

YearOfManufacture.propTypes = {
  yearOfManufacture: PropTypes.string,
  handleChangeYearOfManufacture: PropTypes.func
};

export default YearOfManufacture;



// WEBPACK FOOTER //
// ./src/app/components/quotationPVComponent/yearOfManufacture/YearOfManufacture.js